import * as actions from '~/actions/popover';

const defaultState = {};

const popoverState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.OPEN_POPOVER:
      return Object.assign({}, state, {
        [action.id]: true,
      });
    case actions.CLOSE_POPOVER:
      return Object.assign({}, state, {
        [action.id]: false,
      });
    default:
      return state;
  }
};

export default popoverState;
